import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

const API_ROOT = `${publicRuntimeConfig.apiUrl ?? ''}/api/v2`;

export default API_ROOT;
